// extracted by mini-css-extract-plugin
export var context = "definition-list-module--context--be05b";
export var index = "definition-list-module--index--e8246";
export var learnMore = "definition-list-module--learnMore--b7c1b";
export var outdated = "definition-list-module--outdated--f6f68";
export var termsList = "definition-list-module--termsList--62006";